define('models/accounts/accountmodel',[
    'backbone'
], function(Backbone){
    var AccountModel = Backbone.Model.extend({
        initialize: function(options){
            options = options || {};

            this.instanceURL = options.instanceURL;

            this.accountguid = options.accountguid;
            this.account_name = options.account_name;
            this.account_type_id = options.account_type_id;
            this.allocation_percentage = options.allocation_percentage;
            this.balance = options.balance;
            this.contribution = options.contribution;
            this.created_dt = options.created_dt;
            this.entitytypeid = options.entitytypeid;
            this.target_amount = options.target_amount;
            this.image_name = buildImageURL(pf.enums.entityTypeCodeEnum.Account, options.accountguid, pf.enums.imageTypeGUIDEnum.Thumbnail, options.image_name);
            this.manager_name = options.manager_name;
            this.manager_user_guid = options.manager_user_guid;
            this.proxy_number = options.proxy_number;
            this.purse = options.purse;
        },
        parse: function(data){
            var response = {};

            response.accountguid = data.accountguid;
            response.account_name = data.account_name;
            response.account_type_id = data.account_type_id;
            response.allocation_percentage = data.allocation_percentage;
            response.balance = data.balance;
            response.contribution = data.contribution;
            response.created_dt = data.created_dt;
            response.entitytypeid = data.entitytypeid;
            response.target_amount = data.target_amount;
            response.image_name = buildImageURL(pf.enums.entityTypeCodeEnum.Account, data.accountguid, pf.enums.imageTypeGUIDEnum.Thumbnail, data.image_name);
            response.manager_name = data.manager_name;
            response.manager_user_guid = data.manager_user_guid;
            response.proxy_number = data.proxy_number;
            response.purse = data.purse;
            
            return response;
        }
    });
    return AccountModel;
});

